'use strict';

var _defineProperty = require("/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _objectWithoutProperties = require("/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _excluded = ["arg", "searchParams", "hashAlg", "mtime", "mode"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var modeToString = require('./mode-to-string');
var _require = require('ipfs-core-utils/src/files/normalise-input/utils'),
  mtimeToObject = _require.mtimeToObject;

/**
 * @param {*} params
 * @returns {URLSearchParams}
 */
module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    arg = _ref.arg,
    searchParams = _ref.searchParams,
    hashAlg = _ref.hashAlg,
    mtime = _ref.mtime,
    mode = _ref.mode,
    options = _objectWithoutProperties(_ref, _excluded);
  if (searchParams) {
    options = _objectSpread(_objectSpread({}, options), searchParams);
  }
  if (hashAlg) {
    options.hash = hashAlg;
  }
  if (mtime != null) {
    mtime = mtimeToObject(mtime);
    options.mtime = mtime.secs;
    options.mtimeNsecs = mtime.nsecs;
  }
  if (mode != null) {
    options.mode = modeToString(mode);
  }
  if (options.timeout && !isNaN(options.timeout)) {
    // server API expects timeouts as strings
    options.timeout = "".concat(options.timeout, "ms");
  }
  if (arg === undefined || arg === null) {
    arg = [];
  } else if (!Array.isArray(arg)) {
    arg = [arg];
  }
  var urlSearchParams = new URLSearchParams(options);
  arg.forEach(function (arg) {
    return urlSearchParams.append('arg', arg);
  });
  return urlSearchParams;
};